<template>
  <div class="flex flex-col items-center space-y-3">
    <img src="./assets/request-success.svg" height="70" width="70" alt="" />
    <h4 class="text-lg font-bold">
      {{ $t('request-form.result.success.title') }}
    </h4>
    <p class="text-center">
      {{ $t('request-form.result.success.description') }}
    </p>
    <AuiButton type="button" class="w-full" @click="onProceed">
      {{ $t('request-form.result.success.proceed') }}
    </AuiButton>
  </div>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { AuiButton } from '@aviata/auiata';

  import { Analytics } from '@shared/analytics';
  import { requestFormConfig } from '../config';

  const emit = defineEmits<{
    onProceed: [];
  }>();

  onMounted(() => {
    Analytics.logEvent({
      event: requestFormConfig.analyticsEvents.SUBMIT.SUCCESS,
    });
  });

  const onProceed = () => {
    emit('onProceed');

    Analytics.logEvent({
      event: requestFormConfig.analyticsEvents.PROCEED,
    });
  };
</script>
